module.exports = __webpack_public_path__ + "static/media/sa.d5fb37ef.png";